<div class="block">
    <div class="container">
        <div class="not-found">
            <div class="not-found__404">
                Oops! Error 404
            </div>

            <div class="not-found__content">
                <h1 class="not-found__title">{{"page_not_found"|translate}}</h1>

                <p class="not-found__text">
                    {{"cant_find_page"|translate}}.<br>
                </p>

                <!-- <form class="not-found__search">
                    <input type="text" class="not-found__search-input form-control" placeholder="Search Query...">
                    <button type="submit" class="not-found__search-button btn btn-primary">Search</button>
                </form> -->

                <p class="not-found__text">
                    {{"can_go_homepage"|translate}}.
                </p>

                <a class="btn btn-secondary btn-sm" [routerLink]="['/en']">{{"go_homepage"|translate}}</a>
            </div>
        </div>
    </div>
</div>
